import 'css-chunksrc/client/pages/zonePage/projectsPage/loader/styles.scss';export default {
  "loader": "_loader_114c5_1",
  "header": "_header_114c5_6",
  "addZoneButton": "_addZoneButton_114c5_15",
  "list": "_list_114c5_21",
  "item": "_item_114c5_28"
};